import {mapGetters} from 'vuex'

export const promocodesMixin = {
    computed: {
        ...mapGetters([
            'getPromocodeStates',
            'getPromocodeAudience',
            'getProducts'
        ])
    },
    methods: {
        promocodeRichStatus: function (statusId) {
            return this.getPromocodeStates.filter(state => {
                return state.id == statusId
            })[0]
        },
        promocodeRichAudience: function (audienceId) {
            return this.getPromocodeAudience.filter(state => {
                return state.id == audienceId
            })[0]
        },
        promocodeProducts: function (promocode) {
            let productsArr = []
            if(promocode.isForAllProducts){
                productsArr = this.getProducts
            } else {
                productsArr = promocode.products
            }

            // transform products array to product name array
            let productNamesArr = []
            productsArr.map(product => {
                productNamesArr.push(product.name)
            })

            return productNamesArr
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/promocodes.js